<template>
  <div class="login-page"></div>
</template>
<script>
import VueCookie from "../config/util.cookies";
export default {
  data() {
    return {
      msg: ""
    };
  },
  methods: {
    ssoLogin() {
      let _this = this;
      _this.$Api.get("/api/user/ssoLogin", {}).then(response => {
        if (response.status === 200) {
          let clientId = response.data.clientId;
          let redirectUri = response.data.redirectUri;
          let returnUrl = encodeURIComponent(response.data.returnUrl); // 非local用
          // let returnUrl = encodeURIComponent('http://localhost:8081/qrcode/#/ssoLogin'); // local用
          let ssoUrl = response.data.ssoUrl;
          VueCookie.set("clientId", clientId, {
            expires: "2h"
          });
          VueCookie.set("redirectUri", encodeURIComponent(redirectUri), {
            expires: "2h"
          });
          VueCookie.set("returnUrl", returnUrl, {
            expires: "2h"
          });
          let reloadUrl =
            ssoUrl +
            "?responseType=code&client_id=" +
            clientId +
            "&redirect_uri=&returnUrl=" +
            returnUrl +
            "#/login";
          window.location.href = reloadUrl;
        } else {
          _this.$message({
            message: "单点登录失败!",
            type: "error"
          });
        }
      });
    },
    getUserInfo(token) {
      let _this = this;
      let param = {
        url: "/api/user/getUserInfoByToken",
        params: {
          iamToken: token
        }
      };
      _this.$store.dispatch("ssoLogin", param).then(() => {
        _this.$router.push("/dashboard/home");
        _this.$message({
          type: "success",
          message: "登录成功",
          duration: 3000
        });
      });
    }
  },
  created() {
    let _this = this;
    // let access_token = _this.$route.query.access_token;
    const access_token = VueCookie.get("access_token");
    if (
      access_token === "" ||
      access_token === null ||
      access_token === undefined
    ) {
      _this.ssoLogin();
    } else {
      _this.getUserInfo(access_token);
    }
  }
};
</script>
<style lang="sass" scoped>
footer
    .first-line, .second-line
        text-align: center
        font-size: 14px

    .first-line
        padding-top: 100px
        color: rgb(149, 149, 149)
        margin-bottom: 5px
</style>
